import axios from "src/lib/axios";

export const getPurchaseOrderByAdmin = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
  date = null,
  seller = "",
  sortBy = "createdAt",
  orderCase = "desc",
}) => {
  return axios.get(`/purchase-order/admin/list`, {
    params: {
      status: status,
      seller: seller,
      keyword: keyword,
      orderDate: date,
      page: page,
      page_size: page_size,
      sortBy: sortBy,
      orderCase: orderCase,
    },
  });
};

export const getPurchaseOrderCsvByAdmin = ({
  keyword = null,
  status = "all",
  date = null,
  seller = "",
  sortBy = "createdAt",
  orderCase = "desc",
}) => {
  return axios.get(`/purchase-order/admin/csv`, {
    params: {
      status: status,
      seller: seller,
      keyword: keyword,
      orderDate: date,
      sortBy: sortBy,
      orderCase: orderCase,
    },
  });
};

/**
 *
 * @param {ObjectId} orderId
 * @returns
 */
export const getPurchaseOrderDetail = (id) =>
  axios.get(`/purchase-order/admin/detail/${id}`);

/**
 *
 * @param {ObjectId} orderId
 * @returns
 */
export const generateRefPayNo = (orderId) =>
  axios.get(`/purchase-order/generate-ref-pay-no/${orderId}`);

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {Array} info.orders
 * @returns
 */
export const updatePurchaseOrderDetail = (id, info) => {
  return axios.patch(`/purchase-order/${id}`, info);
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {Array} info.internalNote
 * @returns
 */
export const updateOrderNote = (id, info) => {
  return axios.patch(`/purchase-order/update/note/${id}`, info);
};

// update purchase order status
/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {String} info.refPayNo
 * @param {String} info.status
 * @param {String} info.paymentType
 * @param {String} info.paySlipImage
 * @param {Date} info.slipDate
 * @returns
 */
export const updateStatusInProgress = (id, info) => {
  return axios.patch(`/purchase-order/update/status/in-progress/${id}`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {String} info.qtNumber
 * @param {Date} info.scheduleDate
 * @param {File} info.quotationPdf
 * @param {File} info.quotationOtherPdf
 * @param {String} info.refPayNo
 * @param {String} info.status
 * @param {String} info.paymentType
 * @param {String} info.paySlipOtherImage
 * @param {Date} info.slipDate
 * @returns
 */
export const updateStatusOrdered = (id, info) => {
  return axios.patch(`/purchase-order/update/status/ordered/${id}`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {String} info.qtNumber
 * @param {File | ObjectId} info.quotationPdf
 * @param {File | ObjectId} info.quotationOtherPdf
 * @returns
 */
export const updateQuotationPdf = (id, info) => {
  return axios.patch(`/purchase-order/update/quotation-pdf/${id}`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {String} info.cancelMessage
 * @returns
 */
export const updateStatusCancel = (id, info) => {
  return axios.patch(`/purchase-order/update/status/cancel/${id}`, info);
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {String} info.cancelMessage
 * @param {Number} info.total
 * @param {String} info.remark - optional
 * @returns
 */
export const updateStatusCancelRefund = (id, info) => {
  return axios.patch(`/purchase-order/update/status/cancel-refund/${id}`, info);
};
